
<div class="collection-view">
  <ftu-block
    dismiss-key="collection"
    icon="view_carousel"
    title="This is your Collection"
    description="Collection is a real-time value tracking portfolio tool for your personal collection. Search our database of millions of cards and get advanced, accurate value estimations for any card when adding to your collection. You can even create multiple collections and share them with the Card Ladder community through the Showcase feature."
  />

  <page-header>
    <template #title>
      <align small-gap>
        <icon-button
          :icon="collection.public ? 'public' : 'lock'"
          :tooltip="collection.public ? 'Showcased' : 'Private'"
          :class="{ success: collection.public }"
          @click="handleShare"
        />

        <h1 class="secondary-font">
          {{ collectionName }}
        </h1>

        <dropdown
          v-if="collectionOptions.length"
          align="center"
          :active="menuOpen"
          @close="menuOpen = false"
        >
          <div>
            <icon-button icon="expand_more" @click="menuOpen = !menuOpen" />
          </div>

          <template #menu>
            <dropdown-menu
              :options="collectionOptions"
              @select="handleSelect"
            />
          </template>
        </dropdown>
      </align>
    </template>

    <template #actions>
      <align>
        <icon-button
          v-if="collectionSelectedIds.length && collections.length > 1"
          tooltip="Move selected cards"
          icon="drive_file_move"
          @click="showMoveModal = true"
        />

        <icon-button
          v-if="collectionSelectedIds.length"
          tooltip="Delete selected cards"
          icon="delete_outline"
          :loading="deleting"
          @click="deleteSelectedCards"
        />

        <icon-button
          icon="analytics"
          :tooltip="display === 'cards' ? 'View Collection Stats' : 'Go Back to Cards'"
          :class="{ success: display === 'stats' }"
          @click="display = (display === 'stats') ? 'cards' : 'stats'"
        />

        <icon-button
          tooltip="Collection Settings"
          icon="settings"
          @click="showSettingsModal = true"
        />

        <icon-button
          v-if="showAdd"
          tooltip="Add Card"
          class="add-card"
          icon="add_circle"
          @click="addCard"
        />
      </align>
    </template>
  </page-header>

  <empty-state
    v-if="showEmptyState"
    icon="view_carousel"
    title="You don't have any cards in this collection!"
    description="Cards can be added by clicking the Add button above"
  />

  <template v-else>
    <div class="wrapper">
      <collection-cards-view v-show="display === 'cards'" />
      <collection-stats-view v-if="display === 'stats'" />
    </div>
  </template>

  <collection-create-modal
    :open="showCreateModal"
    @close="showCreateModal = false"
    @create="switchCollection"
  />

  <collection-settings-modal
    :open="showSettingsModal"
    @close="showSettingsModal = false"
    @deleted="handleDeletedCollection"
  />

  <collection-upload-modal
    :open="showUploadModal"
    @close="showUploadModal = false"
  />

  <collection-move-cards-modal
    :open="showMoveModal"
    @close="showMoveModal = false"
  />
</div>
